module.exports = __webpack_public_path__ + "img/myflex.3567f0e8.png";